export default "__VITE_ASSET__BqkYwMG$__"